<div class="flex justify-content-center align-items-center h-full">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 1L1 13M1 1L13 13" [attr.stroke]="stroke()" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
